// File: Otselect.refactor.jsx
// Refactor completo: componente modular, Bootstrap puro, UI moderno
// Contiene: OtSelect (principal), ToolbarActions, TableEquipos, ModalController, hook useOtLogic

import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { getDataobtener } from '../api/common';
import Spinner from '../components/commons/Spinner';
import { ActivarEq, FinalizarEq, NoFinalizarEq } from '../components/EqInOt/FinalizarEq';
import { Canceleq } from '../components/Equipo/Canceleq';
import { Editareq } from '../components/Equipo/Editareq';
import { Observacioneq } from '../components/Equipo/Observacioneq';
import { Modales } from '../components/Modales';
import { Modalcarga } from '../components/Modales/Modalcarga';
import { Otdatacliente } from '../components/Ot/Otdatacliente';
import { Otsonpdf } from '../components/Ot/Otsonpdf';
import { PARENT } from '../constants';
import { useAuth } from "../hooks/useAuth"; 
import HojasTrabajo from '../components/Aprobar/HojasTrabajo';
import {AprobarAll, AprobarSeleccion } from '../components/EqInOt/AprobarSelect';
import DateProgram from '../components/Ot/DateProgram';
import { HojasDeTrabajo } from '../components/Seguimiento/HojasTrabajo';
import { EqFinalizadosTotal } from '../components/Ot/EqFinalizados';
import { ContadoresOt } from '../components/Ot/IndicadoresOt';
import Cabecera from '../components/Ot/Cabecera';
import { AddItems } from '../components/Ot/AddItems';
import ModalHojasTrabajo from '../components/OtSelect/ModalHojasTrabajo';

// -----------------------
// Custom hook: useOtLogic
// -----------------------
function useOtLogic({ id, searchParams }){
  const [ots, setOt] = useState(null);
  const [equiposOtIni, setEquiposOtIni] = useState([]);
  const [sedes, setSedes] = useState([]);
  const [modalCharge, setModalCharge] = useState(false);
  const [refreshFlag, setRefreshFlag] = useState(false);

  console.log('ots en useOtLogic:', ots);
  const task = searchParams.get('task');

  // fetch OT
  useEffect(()=>{
    let mounted = true;
    async function load(){
      setModalCharge(true);
      try{
        const otDB = await getDataobtener(id);
        if(!mounted) return;
        const data = otDB?.data?.data || {};
        setOt(data);
        if(searchParams.get('orden')){
          const EquiposDisponibles = task === 'revisar' ? data.equipos : data.equipos.filter(eq => (!eq.fechaCalibracion));
          setEquiposOtIni(EquiposDisponibles);
        }
      }catch(err){
        console.error('Error cargando OT', err);
      }finally{
        if(mounted) setModalCharge(false);
      }
    }
    load();
    return ()=> mounted=false;
  },[id, refreshFlag, searchParams, task]);

  const toggleRefresh = useCallback(()=> setRefreshFlag(f=>!f),[]);

  return { ots, setOt, equiposOtIni, setEquiposOtIni, sedes, setSedes, modalCharge, setModalCharge, refreshFlag, toggleRefresh };
}

// -----------------------
// ToolbarActions component
// -----------------------
const ToolbarActions = ({ task, onCreateHT, onAddItems, onOpenHT, onExport }) => {
  return (
    <div className="d-flex justify-content-between align-items-center mb-3">
      <div>
        {task!=='revisar' && (
          <button className="btn btn-success me-2" onClick={onCreateHT}>Crear Hoja de Trabajo</button>
        )}
      </div>
      <div className="d-flex gap-2">
        <button className="btn btn-outline-secondary" onClick={onAddItems}>Add Ítems</button>
        <button className="btn btn-outline-secondary" onClick={()=>onOpenHT('Equipos Finalizados')}>Finalizados</button>
        <button className="btn btn-outline-secondary" onClick={()=>onOpenHT('Hojas de Trabajo')}>H. Trabajo</button>
        <button className="btn btn-outline-secondary" onClick={onExport}>Exportar <i className="bi bi-file-earmark-spreadsheet ms-1"/></button>
      </div>
    </div>
  );
};

// -----------------------
// TableEquipos component
// -----------------------
const TableEquipos = ({ equipos, task, onEdit, onCancel, onObserv, onFinalize, onActivate, onNoFinalize, onApproveToggle, selectAll, onSelectAllChange, equiSelectRef, currentUser }) => {
  // keys search kept in parent - table only renders

  return (
    <div className="table-responsive">
      <table className="table table-striped table-hover table-bordered align-middle">
        <thead className="table-info">
          <tr>
            <th style={{width: '50px'}}>No.</th>
            <th>Item</th>
            <th>Marca</th>
            <th>Modelo</th>
            <th>Serie</th>
            <th>Inventario</th>
            <th>Ubicación</th>
            <th>Consec.</th>
            <th>Resolución</th>
            <th>Puntos</th>
            <th>Res</th>
            <th>Sede</th>
            <th><i className="bi bi-eye-fill"/></th>
            <th className="text-center">Acción</th>
            <th className="text-center">Editar</th>
            <th className="text-center">Cancelar</th>
          </tr>
        </thead>
        <tbody>
          {equipos?.map((eq, idx)=>(
            <tr key={eq._id || idx} className={eq.estado === 'Cancelado'? 'table-secondary':''}>
              <td>{idx+1}</td>
              <td className="text-primary" style={{cursor:'pointer'}} onClick={()=> window.open(`/perfilEq?_id=${eq.equipo._id}`, '_blank')}>{eq?.equipo?.item?.nombre}</td>
              <td>{eq?.equipo?.marca}</td>
              <td>{eq?.equipo?.modelo}</td>
              <td>{eq?.equipo?.serie}</td>
              <td>{eq?.equipo?.inventario}</td>
              <td>{eq?.equipo?.ubicacion}</td>
              <td>{eq?.consecutivo}</td>
              <td>{eq?.equipo?.resolucion}</td>
              <td>{eq?.equipo?.puntos}</td>
              <td>{eq?.responsable?.nombre}</td>
              <td>{eq?.equipo?.sedeClient?.nameSede}</td>
              <td>{eq.observacion? <i className="bi bi-eye-fill cursor-pointer" onClick={()=>onObserv(eq)}/>: null}</td>
              <td className="text-center">
                {/* estados y acciones principales */}
                {task==='finalizar' ? (
                  eq.estado==='Cancelado'?(<i className="bi bi-x-square-fill"></i>) :
                  eq.estado==='Procesado'?(<i className="bi bi-check-square-fill cursor-pointer" onClick={()=>onNoFinalize(eq)}/>):
                  (eq.estado==='Pendiente' || eq.estado==='Aplazado')?(<i className="bi bi-pause-circle-fill cursor-pointer" onClick={()=>onActivate(eq)}/>):
                  eq.estado==='En Proceso'?(<i className="bi bi-gear-wide-connected text-info" title="Equipo en calibración — administrar desde su lote" style={{cursor:'not-allowed', opacity:0.7}}/>):
                  (<i className="bi bi-check-square cursor-pointer" onClick={()=>onFinalize(eq)}/>)
                ) : (
                  // revisar
                  eq.estado==='No Finalizado'? (<i className="text-muted">No Fin</i>) :
                  eq.estado==='Cancelado'? (<i className="bi bi-x-square-fill text-danger"></i>) : (<i className="bi bi-check2 text-success"></i>)
                )}
              </td>
              <td className="text-center"><i className={eq.estado === 'Cancelado'? 'text-muted bi bi-pencil-square':'bi bi-pencil-square cursor-pointer'} onClick={()=>onEdit(eq)}/></td>
              <td className="text-center"><i className={eq.estado === 'Cancelado'? 'text-muted bi bi-x-circle':'bi bi-x-circle cursor-pointer'} onClick={()=>onCancel(eq)}/></td>
            </tr>
          ))}
        </tbody>
      </table>
      {!equipos?.length && <div className="alert alert-light">No hay equipos para mostrar.</div>}
    </div>
  );
};

// -----------------------
// ModalController component
// -----------------------
const ModalController = ({ accion, estadomodal, setEstadomodal, equipoinfo, ots, handlers, propsExtra }) => {
  // handlers contains setRefresh, setModalCharge, etc as needed
  return (
    <Modales estado={estadomodal} cambiarestado={setEstadomodal} titulo={`${accion.tarea} : ${accion.titulo}`}>
      <div>
        { accion.tarea === 'Editar' && <Editareq infoOt={ots} refrescar={handlers.toggleRefresh} refresh={propsExtra.refresh} infoequipo={equipoinfo} cambiarestado={setEstadomodal} setEquiposOtIni={propsExtra.setEquiposOtIni} /> }
        { accion.tarea === 'Cancelar' && <Canceleq infoOt={ots} cambiarestado={setEstadomodal} iditem={equipoinfo._id} setEquiposOtIni={propsExtra.setEquiposOtIni} refresh={propsExtra.refresh} setRefresh={handlers.toggleRefresh}/> }
        { accion.tarea === 'Editar Cliente' && <Otdatacliente infocliente={ots?.cliente} cambiarestado={setEstadomodal} refrescar={handlers.toggleRefresh} refresh={propsExtra.refresh} /> }
        { accion.tarea === 'Hoja de Trabajo' && <Otsonpdf cambiarestado={setEstadomodal} sitioSeleted={propsExtra.sitioSeleted} setRefresh={propsExtra.setRefresh} refresh={propsExtra.refresh} otFath={ots} EqSedeFilter={propsExtra.EqSedeFilter} obsGen={propsExtra.obsGen} /> }
        { accion.tarea === 'Observacion' && <Observacioneq cambiarestado={setEstadomodal} infoobservacion={equipoinfo?.observacion} /> }
        { accion.tarea === "Adicionar Ítems" && <AddItems setEstadoModal={setEstadomodal} idOt={ots?._id} ot={ots} setRefresh={propsExtra.setRefresh} refresh={propsExtra.refresh} cliente={ots?.cliente} sedeSeleted={propsExtra.sedeSeleted} sedes={propsExtra.sedes} SetModalcharge={propsExtra.SetModalcharge} historialeq={propsExtra.historialeq} setHistorialEq={propsExtra.setHistorialEq}/> }
        { accion.tarea === "Hojas de Trabajo" && <HojasDeTrabajo setEstadoModal={setEstadomodal} orden={ots?.numeroOrden} setRefresh={propsExtra.setRefresh} refresh={propsExtra.refresh} /> }
        { accion.tarea === "Equipos Finalizados" && <EqFinalizadosTotal setEstadoModal={setEstadomodal} ot={ots} setRefresh={propsExtra.setRefresh} refresh={propsExtra.refresh} /> }
      </div>
    </Modales>
  );
};

// -----------------------
// OtSelect (principal)
// -----------------------
export const OtSelectTwo = ()=>{
  const [searchParams] = useSearchParams();
  const { id } = useParams();
  const task = searchParams.get('task');

  const { ots, setOt, equiposOtIni, setEquiposOtIni, sedes, setSedes, modalCharge, setModalCharge, toggleRefresh } = useOtLogic({ id, searchParams });

  const userData = useAuth();
  const result = userData.userData;

  // UI states
  const [estadomodal, setEstadomodal] = useState(false);
  const [accion, setAccion] = useState({ tarea:'', titulo:'' });
  const [equipoinfo, setEquipoinfo] = useState(null);
  const [sedeSeleted, setSedeSeleted] = useState(null);
  const [sitioSeleted, setSitioSeleted] = useState(null);
  const [optionAproved, setOptionAproved] = useState(null);
  const [query, setQuery] = useState('');
  const [obsGen, setObsGen] = useState('');

  // Modal de Hojas de Trabajo
  const [showModalHT, setShowModalHT] = useState(false);
  const [cacheHT, setCacheHT] = useState(null);

  // selection ref to avoid re-renders
  const equiSelectRef = useRef([]);
  const [fakeState, setFakeState] = useState(false); // to force small re-renders for checkbox UI
  const [selectAll, setSelectAll] = useState(false);

  // Filters with useMemo
  const EqSitioFilter = useMemo(()=>{
    if(!sitioSeleted) return equiposOtIni;
    return sitioSeleted === 'Sitio' ? equiposOtIni.filter(e=>!e.fechaIngreso) : equiposOtIni.filter(e=>e.fechaIngreso);
  },[sitioSeleted, equiposOtIni]);

  const EqSedeFilter = useMemo(()=>{
    if(!sedeSeleted) return EqSitioFilter;
    return EqSitioFilter.filter(item=> item?.equipo?.sedeClient?._id === sedeSeleted);
  },[sedeSeleted, EqSitioFilter]);

  const equiposOt = useMemo(()=>{
    if(!query) return EqSedeFilter;
    const keys=["consecutivo","marca","modelo","serie","sede","resolucion","puntos","inventario","ubicacion","nombre"];
    return EqSedeFilter.filter(({equipo}) => keys.some(k=>{
      const val = equipo?.[k] || equipo?.item?.[k];
      return val?.toString().toLowerCase().includes(query.toLowerCase());
    }));
  },[query, EqSedeFilter]);

  // Actions handlers
  const handleFinalize = useCallback(async (eq)=>{
    setModalCharge(true);
    const updated = await FinalizarEq(eq._id, ots?.numeroOrden, ots?.visitas, setModalCharge, result);
    if(updated) toggleRefresh();
  },[ots, result, toggleRefresh]);

  const handleActivate = useCallback(async (eq)=>{
    setModalCharge(true);
    const updated = await ActivarEq(eq._id, ots?.numeroOrden, ots?.visitas, setModalCharge, result, ots, eq, ()=>({}));
    if(updated) toggleRefresh();
  },[ots, result, toggleRefresh]);

  const handleNoFinalize = useCallback(async (eq)=>{
    setModalCharge(true);
    const updated = await NoFinalizarEq(eq._id, setModalCharge, task);
    if(updated) toggleRefresh();
  },[task, toggleRefresh]);

  const handleEdit = (eq)=>{ setEquipoinfo(eq); setAccion({tarea:'Editar', titulo: eq.equipo?.item?.nombre}); setEstadomodal(true);} 
  const handleObserv = (eq)=>{ setEquipoinfo(eq); setAccion({tarea:'Observacion', titulo: eq.equipo?.item?.nombre}); setEstadomodal(true);} 
  const handleCancel = (eq)=>{ setEquipoinfo(eq); setAccion({tarea:'Cancelar', titulo: eq.equipo?.item?.nombre}); setEstadomodal(true);} 

  const handleAddItems = ()=>{ setAccion({tarea:'Adicionar Ítems', titulo:''}); setEstadomodal(true); }
  const handleOpenHT = (title)=>{ 
    if (title === 'Hojas de Trabajo') {
      setShowModalHT(true);
    } else {
      setAccion({tarea:title, titulo: ots?.numeroOrden + '-' + ots?.visitas}); 
      setEstadomodal(true);
    }
  }
  const handleCreateHT = ()=>{ setAccion({tarea:'Hoja de Trabajo', titulo: ots?.numeroOrden + '-' + ots?.visitas}); setEstadomodal(true); }
  const handleExport = ()=> DateProgram(ots);

  const aprovarAllCheck = (e)=>{
    const checked = e.target.checked;
    setSelectAll(checked);
    if(checked){
      // seleccionar todos
      equiSelectRef.current = [...equiposOt];
    }else{
      equiSelectRef.current = [];
    }
    setFakeState(s=>!s);
  }

  const aprovarOneToggle = (eq)=>{
    const exists = equiSelectRef.current.some(o=>o._id===eq._id);
    if(exists){ equiSelectRef.current = equiSelectRef.current.filter(o=>o._id!==eq._id);} else { equiSelectRef.current.push(eq);} 
    setSelectAll(false);
    setFakeState(s=>!s);
  }

  const handleObsOt = (e)=> setObsGen(e.target.value);

  // render
  return (
    <div className="container py-3">
      {ots && <Cabecera ots={ots} selectSede={setSedeSeleted} sedeSeleted={sedeSeleted} setSitioSeleted={setSitioSeleted} refresh={false} setSedes={setSedes} />}
      <ContadoresOt ots={ots} />

      <Modalcarga estadoIn={modalCharge} cambiarestadoIn={setModalCharge}><Spinner/></Modalcarga>

      <ModalController accion={accion} estadomodal={estadomodal} setEstadomodal={setEstadomodal} equipoinfo={equipoinfo} ots={ots} handlers={{ toggleRefresh }} propsExtra={{ refreshFlag: null, setEquiposOtIni, refresh: null, sitioSeleted, EqSedeFilter, obsGen, sedeSeleted, sedes, SetModalcharge: setModalCharge }} />

      <div className="mb-3">
        {task==='revisar'? null : <textarea className="form-control" placeholder="Observación" rows={2} onChange={handleObsOt} />}
      </div>

      <ToolbarActions task={task} onCreateHT={handleCreateHT} onAddItems={handleAddItems} onOpenHT={handleOpenHT} onExport={handleExport} />

      {task==='revisar' && (
        <div className="d-flex align-items-center gap-2 mb-2">
          <button className="btn btn-outline-primary" onClick={()=>setOptionAproved()}>Individual</button>
          <button className="btn btn-outline-primary" onClick={()=>setOptionAproved('Htrabajo')}>H. Trabajo</button>
          { !optionAproved && equiSelectRef.current.length>0 ? <button className="btn btn-success" onClick={()=>AprobarSeleccion(equiSelectRef.current, result, ots?.numeroOrden, ots?.visitas, setModalCharge, null, null)}>Aprobar</button> : <div/> }
        </div>
      )}

      {!optionAproved && (
        <div className="mb-3">
          <input type="text" className="form-control" placeholder="Ingresa un dato del item a buscar" value={query} onChange={e=>setQuery(e.target.value)} />
        </div>
      )}

      <div className="card shadow-sm">
        <div className="card-body">
          <TableEquipos equipos={equiposOt} task={task} onEdit={handleEdit} onCancel={handleCancel} onObserv={handleObserv} onFinalize={handleFinalize} onActivate={handleActivate} onNoFinalize={handleNoFinalize} equiSelectRef={equiSelectRef} selectAll={selectAll} onSelectAllChange={aprovarAllCheck} currentUser={result} />
        </div>
      </div>

      {optionAproved==='Htrabajo' && <HojasTrabajo Orden={ots?.numeroOrden} SetModalcharge={setModalCharge} setRefresh={toggleRefresh} refresh={null} />}
      
      {/* Modal de Hojas de Trabajo */}
      <ModalHojasTrabajo
        show={showModalHT}
        onHide={() => setShowModalHT(false)}
        numeroOrden={ots?.numeroOrden}
        cache={cacheHT}
        setCache={setCacheHT}
        onRefresh={toggleRefresh}
      />
    </div>
  );
};

// End of file
